// extracted by mini-css-extract-plugin
export var cardLayout = "_9c-1";
export var paginationContainer = "_9c-0";